import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import AdminLogin from './components/admin/Login';
import AdminDashboard from './components/admin/Dashboard';
import PrivateRoute from './components/admin/PrivateRoute';
import './components/admin/AdminStyles.css';
import SuperAdminLogin from './components/superadmin/SuperAdminLogin';
import SuperAdminDashboard from './components/superadmin/SuperAdminDashboard';
import AddSchool from './components/superadmin/AddSchool';
import Schools from './components/superadmin/Schools';
import StudentDashboard from './components/student/StudentDashboard';
import SuperAdminPrivateRoute from './components/superadmin/SuperAdminPrivateRoute';
import './components/superadmin/SuperAdminStyles.css';
import './components/superadmin/SuperAdminDashboard.css';
import SchoolLogin from './components/school/SchoolLogin';
import SchoolDashboard from './components/school/SchoolDashboard';
import ForgotPassword from './components/school/ForgotPassword';
import AddClass from './components/school/AddClass';
import AddStudent from './components/school/AddStudent';
import AddTeacher from './components/school/AddTeacher';
import AddCook from './components/school/AddCook';
import Cooks from './components/school/Cooks';
import Classes from './components/school/Classes';
import Students from './components/school/Students';
import StudentApprovals from './components/school/StudentApprovals';
import Teachers from './components/school/Teachers';
import Parents from './components/school/Parents';
import Schedule from './components/school/Schedule';
import SchoolTiming from './components/school/SchoolTiming';
import ClassSchedule from './components/school/ClassSchedule';
import ScheduleView from './components/school/ScheduleView';
import CardGeneration from './components/school/CardGeneration';
import ExamSchedule from './components/school/ExamSchedule';
import SetFees from './components/school/SetFees';
import AnnualFeesMaster from './components/school/AnnualFeesMaster';
import ClassMapping from './components/school/ClassMapping';
import Billing from './components/school/Billing';
import InvoicePreview from './components/school/InvoicePreview';
import PaymentsReceipts from './components/school/PaymentsReceipts';
import TransactionsPreview from './components/school/TransactionsPreview';
import StatementsPreview from './components/school/StatementsPreview';
import StatementHeaderFooter from './components/school/StatementHeaderFooter';
import FeeSchedule from './components/school/FeeSchedule';
import StudentFees from './components/school/StudentFees';
import FeeRecords from './components/school/FeeRecords';
import AttendanceRecords from './components/school/AttendanceRecords';
import SchoolHomework from './components/school/SchoolHomework';
import AddVehicle from './components/school/AddVehicle';
import AddTransportPerson from './components/school/AddTransportPerson';
import TransportPersons from './components/school/TransportPersons';
import AddReceptionist from './components/school/AddReceptionist';
import Receptionists from './components/school/Receptionists';
import Notices from './components/school/Notices';
import MyAccount from './components/school/MyAccount';
import './components/school/SchoolLogin.css';
import './components/school/SchoolDashboard.css';
import Home from './components/Home';
import PlaceholderDashboard from './components/PlaceholderDashboard';
import TransporterLogin from './components/transporter/TransporterLogin';
import TransporterDashboard from './components/transporter/TransporterDashboard';
import ParentDashboard from './components/parent/ParentDashboard';
import TeacherDashboard from './components/teacher/TeacherDashboard';
import ReceptionistLogin from './components/receptionist/ReceptionistLogin';
import ReceptionistDashboard from './components/receptionist/ReceptionistDashboard';
import ReportCardManagement from './components/school/ReportCardManagement';
import ExamReportCards from './components/school/ExamReportCards';
import VehicleManagement from './components/school/VehicleManagement';
import Vehicles from './components/school/Vehicles';
import SchoolPolicies from './components/school/SchoolPolicies';
import ContactUs from './components/school/ContactUs';
import AddPickupLocation from './components/school/AddPickupLocation';
import PickupLocations from './components/school/PickupLocations';
import AddRoute from './components/school/AddRoute';
import SchoolRoutes from './components/school/Routes';
import BusSeatManagement from './components/school/BusSeatManagement';
import EditVehicle from './components/school/EditVehicle';
import AddMeal from './components/school/AddMeal';
import Meals from './components/school/Meals';
import Settings from './components/school/Settings';
import CurriculumForm from './components/school/CurriculumForm';
import AnnualCalendarForm from './components/school/AnnualCalendarForm';
import BiReports from './components/school/BiReports';
import ReportView from './components/school/reports/ReportView';
import SchoolChat from './components/school/SchoolChat';
import ChatGroups from './components/school/ChatGroups';
import AdminChats from './components/school/AdminChats';
import Upgrade from './components/school/Upgrade';
import AddUser from './components/school/AddUser';
import Users from './components/school/Users';
import UserLogin from './components/school/UserLogin';
import TermsAndConditions from './components/superadmin/TermsAndConditions';
import PrivacyPolicy from './components/superadmin/PrivacyPolicy';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Home page with login options */}
          <Route path="/" element={<Home />} />
          
          {/* Admin routes */}
          <Route path="/admin" element={<AdminLogin />} />
          
          {/* Super Admin routes */}
          <Route path="/superadmin" element={<SuperAdminLogin />} />
          
          {/* School routes */}
          <Route path="/schoollogin" element={<SchoolLogin />} />
          <Route path="/userlogin" element={<UserLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/school/dashboard" element={<SchoolDashboard />} />
            <Route path="/school/add-class" element={<AddClass />} />
            <Route path="/school/add-student" element={<AddStudent />} />
            <Route path="/school/add-teacher" element={<AddTeacher />} />
            <Route path="/school/add-cook" element={<AddCook />} />
            <Route path="/school/cooks" element={<Cooks />} />
            <Route path="/school/add-transport-person" element={<AddTransportPerson />} />
            <Route path="/school/transport-persons" element={<TransportPersons />} />
            <Route path="/school/add-receptionist" element={<AddReceptionist />} />
            <Route path="/school/receptionists" element={<Receptionists />} />
            <Route path="/school/classes" element={<Classes />} />
            <Route path="/school/students" element={<Students />} />
            <Route path="/school/student-approvals" element={<StudentApprovals />} />
            <Route path="/school/teachers" element={<Teachers />} />
            <Route path="/school/parents" element={<Parents />} />
            <Route path="/school/schedule" element={<Schedule />} />
            <Route path="/school/class-schedule" element={<ClassSchedule />} />
            <Route path="/school/schedule-view" element={<ScheduleView />} />
            <Route path="/school/card-generation" element={<CardGeneration />} />
            <Route path="/school/exam-schedule" element={<ExamSchedule />} />
            <Route path="/school/exam-report-cards" element={<ExamReportCards />} />
            <Route path="/school/set-fees" element={<SetFees />} />
            <Route path="/school/annual-fees-master" element={<AnnualFeesMaster />} />
            <Route path="/school/class-mapping" element={<ClassMapping />} />
            <Route path="/school/billing" element={<Billing />} />
            <Route path="/school/invoice-preview" element={<InvoicePreview />} />
            <Route path="/school/payments-receipts" element={<PaymentsReceipts />} />
            <Route path="/school/transactions-preview" element={<TransactionsPreview />} />
            <Route path="/school/transactions-reports" element={<TransactionsPreview />} />
            <Route
              path="/school/receipts-report"
              element={
                <TransactionsPreview
                  pageTitle="Receipts Report"
                  pageSubtitle="View, filter, print, and export payment receipt reports"
                  excelSheetName="Receipts"
                  excelFilePrefix="Receipts"
                  dateHeader="Receipt Date"
                  detailTitle="Receipt Details"
                />
              }
            />
            <Route path="/school/statements-preview" element={<StatementsPreview />} />
            <Route path="/school/statement-header-footer" element={<StatementHeaderFooter />} />
            <Route path="/school/fee-schedule" element={<FeeSchedule />} />
            <Route path="/school/fee-records" element={<FeeRecords />} />
            <Route path="/school/student-fees" element={<StudentFees />} />
            <Route path="/school/attendance-records" element={<AttendanceRecords />} />
            <Route path="/school/homework" element={<SchoolHomework />} />
            <Route path="/school/add-vehicle" element={<AddVehicle />} />
            <Route path="/school/edit-vehicle/:id" element={<EditVehicle />} />
            <Route path="/school/vehicles" element={<VehicleManagement />} />
            <Route path="/school/vehicle" element={<Vehicles />} />
            <Route path="/school/add-pickup-location" element={<AddPickupLocation />} />
            <Route path="/school/pickup-locations" element={<PickupLocations />} />
            <Route path="/school/add-route" element={<AddRoute />} />
            <Route path="/school/routes" element={<SchoolRoutes />} />
            <Route path="/school/bus-seat-management" element={<BusSeatManagement />} />
            <Route path="/school/add-meal" element={<AddMeal />} />
            <Route path="/school/meals" element={<Meals />} />
            <Route path="/school/settings" element={<Settings />} />
            <Route path="/school/policies" element={<SchoolPolicies />} />
            <Route path="/school/contact-us" element={<ContactUs />} />
            <Route path="/school/upgrade" element={<Upgrade />} />
            <Route path="/school/users" element={<Users />} />
            <Route path="/school/add-user" element={<AddUser />} />
            <Route path="/school/report-cards" element={<ReportCardManagement />} />
            <Route path="/school/notices" element={<Notices />} />
            <Route path="/school/chat" element={<SchoolChat />} />
            <Route path="/school/chat-groups" element={<ChatGroups />} />
            <Route path="/school/admin-chats" element={<AdminChats />} />
            <Route path="/school/timing" element={<SchoolTiming />} />
            <Route path="/school/my-account" element={<MyAccount />} />
            <Route path="/school/curriculum-form" element={<CurriculumForm />} />
            <Route path="/school/annual-calendar-form" element={<AnnualCalendarForm />} />
            <Route path="/school/bi-reports" element={<BiReports />} />
            <Route path="/school/bi-reports/dashboard" element={<BiReports />} />
            <Route path="/school/bi-reports/reports" element={<BiReports />} />
            <Route path="/school/reports/:reportType" element={<ReportView />} />
          
          {/* Protected Super Admin routes */}
          <Route element={<SuperAdminPrivateRoute />}>
            <Route path="/superadmin/dashboard" element={<SuperAdminDashboard />} />
            <Route path="/superadmin/add-school" element={<AddSchool />} />
            <Route path="/superadmin/schools" element={<Schools />} />
            <Route path="/superadmin/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/superadmin/privacy-policy" element={<PrivacyPolicy />} />
          </Route>
          
          {/* Protected admin routes */}
          <Route element={<PrivateRoute />}>
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Route>
          
          {/* Student, Parent, Teacher, and Transporter routes */}
          <Route path="/student/dashboard" element={<StudentDashboard />} />
          <Route path="/student/schedule" element={<StudentDashboard />} />
          <Route path="/student/fees" element={<StudentDashboard />} />
          <Route path="/student/attendance" element={<StudentDashboard />} />
          <Route path="/student/homework" element={<StudentDashboard />} />
          <Route path="/student/exam-schedule" element={<StudentDashboard />} />
          <Route path="/student/results" element={<StudentDashboard />} />
          <Route path="/student/chat" element={<StudentDashboard />} />
          <Route path="/student/transport" element={<StudentDashboard />} />
          <Route path="/student/meals" element={<StudentDashboard />} />
          <Route path="/student/policies" element={<StudentDashboard />} />
          <Route path="/student/contact-us" element={<StudentDashboard />} />
          <Route path="/parent/dashboard" element={<ParentDashboard />} />
          <Route path="/parent/children" element={<ParentDashboard />} />
          <Route path="/parent/homework" element={<ParentDashboard />} />
          <Route path="/parent/attendance" element={<ParentDashboard />} />
          <Route path="/parent/fees" element={<ParentDashboard />} />
          <Route path="/parent/schedule" element={<ParentDashboard />} />
          <Route path="/parent/exam-schedule" element={<ParentDashboard />} />
          <Route path="/parent/results" element={<ParentDashboard />} />
          <Route path="/parent/chat" element={<ParentDashboard />} />
          <Route path="/parent/transport" element={<ParentDashboard />} />
          <Route path="/parent/meals" element={<ParentDashboard />} />
          <Route path="/parent/policies" element={<ParentDashboard />} />
          <Route path="/parent/contact-us" element={<ParentDashboard />} />
          
          
          <Route path="/teacher/dashboard" element={<TeacherDashboard />} />
          <Route path="/teacher/schedule" element={<TeacherDashboard />} />
          <Route path="/teacher/attendance" element={<TeacherDashboard />} />
          <Route path="/teacher/records" element={<TeacherDashboard />} />
          <Route path="/teacher/homework" element={<TeacherDashboard />} />
          <Route path="/teacher/exams" element={<TeacherDashboard />} />
          <Route path="/teacher/chat" element={<TeacherDashboard />} />
          <Route path="/teacher/ai-chat" element={<TeacherDashboard />} />
          <Route path="/transporter/login" element={<TransporterLogin />} />
          <Route path="/transporter/dashboard" element={<TransporterDashboard />} />
          
          {/* Receptionist routes */}
          <Route path="/admission/login" element={<ReceptionistLogin />} />
          <Route path="/admission" element={<ReceptionistDashboard />} />
          <Route path="/admission/add-student" element={<ReceptionistDashboard />} />
          <Route path="/admission/students-records" element={<ReceptionistDashboard />} />
          
          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
